import React, {Component} from 'react';

import {Grid} from '@material-ui/core';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import Header from "../general/header";
import SLPPerFuel from "./slpPerFuel";
import PerformancePerTurn from './performancePerTurn';
import PyramidPerSegment from './pyramidPerSegment';
import './styles.scss';
import OurPartners from "./ourPartners";
import LoadingSpinner from "../../components/spinner/Spinner";

import ProfileFromPartnerCategory from './profileFromPartnerCategory';
import {
    fetchFilters
} from "../../actions/navigation_actions";
import Title from "./common/title/Title";
import AssociatesBehavior from "./associatesBehavior/AssociatesBehavior";


class DashboardSLP extends Component {

    componentDidMount() {
        this.props.fetchFilters();
    }

    render() {
        console.log(this.props.navigation);
        return (
            <div className={'main-section dashboardSLP-section'}>
                <Header title={'SLP'}/>
                {this.props.navigation.selectedStation !== -1 &&
                <div>
                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <div className={'spl-per-fuel-section'}>
                                <Title>Penetración Shell LATAM Pass</Title>
                                <div style={{display: 'flex', flexDirection: "row", width: '95%', minHeight: 475}}>
                                    <Grid item xs={7}>
                                        <SLPPerFuel/>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <PerformancePerTurn/>
                                    </Grid>
                                </div>
                            </div>
                        </Grid>
                    </Grid>

                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <div className={'associates-behavior-section'}>
                                <Title>Comportamiento de sus socios</Title>
                                <AssociatesBehavior/>
                            </div>
                        </Grid>
                    </Grid>

                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <div className={'spl-per-fuel-section'}>
                                <Title>Categoría de sus socios</Title>
                                <div style={{display: 'flex', flexDirection: "row", minHeight: 475}}>
                                    <Grid item xs={5}>
                                        <PyramidPerSegment/>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <ProfileFromPartnerCategory/>
                                    </Grid>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <OurPartners/>
                        </Grid>
                    </Grid>
                </div>}

                {this.props.navigation.selectedStation === -1 &&
                <div>
                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <div className={'spl-per-fuel-section'}>
                                {this.props.navigation.areas.length===0  &&
                                <div style={{marginTop:200}}>
                                    <LoadingSpinner className={'spinner'} width={50}/>
                                </div>
                                }
                                {this.props.navigation.areas.length>=1 &&
                                <div className="empty-state">
                                    Por favor seleccione una estación de servicio para continuar.
                                    Estamos trabajando en las vistas de Área y Zona.</div>}
                            </div>
                        </Grid>
                    </Grid>
                </div>}
            </div>
        );
    }
}


const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({fetchFilters}, dispatch);
};

const mapStateToProps = (state) => {
    return {
        navigation: state.navigation,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSLP);



// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/DashboardSLP.js